import { useQuery } from '@tanstack/react-query'
import { getBulkImportSession } from '../../../api/plan-override-bulk-imports-api'
import { BulkImportStatus } from '../../../api/dto/bulk-import-session.dto'

export const BULK_IMPORT_SESSION_QUERY_KEY = 'bulkImportSession'

export function useBulkImportSessionPolling(sessionId: string | null) {
  return useQuery({
    queryKey: [BULK_IMPORT_SESSION_QUERY_KEY, sessionId],
    queryFn: () => getBulkImportSession(sessionId as string),
    enabled: !!sessionId,
    refetchInterval: (query) =>
      query.state.data?.status === BulkImportStatus.PROCESSING ? 5000 : false,
    refetchIntervalInBackground: false,
  })
}
